import { IconButton, styled } from '@mui/material';

export const MinimalIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  height: '32px',
  position: 'absolute',
  backgroundColor: 'transparent !important',
  zIndex: 2,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'transparent',
    '&& svg': { color: theme.vars.palette.grey[500] },
  },
}));

export const ShadowLeft = styled('div')(({ theme }) => ({
  position: 'absolute',
  height: '100%',
  width: '40px',
  top: 0,
  left: 0,
  zIndex: 2,
  background:
    theme.direction === 'ltr'
      ? 'linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.00) 30%)'
      : 'linear-gradient(270deg, #000 0%, rgba(0, 0, 0, 0.00) 30%) /*! @noflip */',

  [theme.breakpoints.up('md')]: {
    background:
      theme.direction === 'ltr'
        ? 'linear-gradient(90deg, #000 40%, rgba(0, 0, 0, 0.00) 100%)'
        : 'linear-gradient(270deg, #000 40%, rgba(0, 0, 0, 0.00) 100%) /*! @noflip */',
  },
}));

export const ShadowRight = styled('div')(({ theme }) => ({
  position: 'absolute',
  height: '100%',
  width: '40px',
  top: 0,
  right: 0,
  zIndex: 2,
  background:
    theme.direction === 'ltr'
      ? 'linear-gradient(270deg, #000 0%, rgba(0, 0, 0, 0.00) 30%)'
      : 'linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.00) 30%)  /*! @noflip */',
  [theme.breakpoints.up('md')]: {
    background:
      theme.direction === 'ltr'
        ? 'linear-gradient(270deg, #000 40%, rgba(0, 0, 0, 0.00) 100%)'
        : 'linear-gradient(90deg, #000 40%, rgba(0, 0, 0, 0.00) 100%) /*! @noflip */',
  },
}));
